<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><span class="gbold">ACKNOWLEDGMENTS</span></h2>
<p class="noindent">Many thanks to all the wonderful folks at Morgan James for publishing this book and for guiding me through the process in such a kind, encouraging, and professional manner.</p>
<p class="indent">I am so grateful to Tom Dean for catching the vision for this book and for being a mentor and friend throughout the process.</p>
<p class="indent">Thanks also to my friend Mary Jo Tate for her extraordinary editing skills. She makes me a better writer.</p>
<p class="indent">To my husband, Mont, and to my ten children (You read that right!), I could never do what I do without your support. I love each of you more than words could ever say.</p>
<p class="indent">And to Jesus: “To you alone; to you alone and not to me must glory be given because of your constant love and faithfulness” (Psalm 115:1).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?5dd164e5